
export function applicantAssessmentUrls(applicantId, done) {
  return simpleIsoFetch => () => {

    simpleIsoFetch.get(`/api/applicants/${applicantId}/assessments/urls`)
      .then(({body: {data: {items: [assessmentUrls]}}}) =>
        done ? done(null, assessmentUrls) : assessmentUrls
      )
      .catch(err => done ? done(err) : Promise.reject(err))
    ;

  };
}

export function updateApplicantAssessments(applicantId, assessments, done) {
  return simpleIsoFetch => () => {

    simpleIsoFetch.post({
        route: `/api/applicants/${applicantId}/assessments`,
        body : assessments
      })
      .then(() => done(null))
      .catch(done)
    ;

  };

}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/assessments.js